export default __webpack_public_path__ + "images/paymentBlockImg2.a69dfbc.jpg";